import { apiSlice } from '@/api'

export const incidentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllIncidents: builder.query({
      query: (buildingId) => ({
        url: `api/v2/incidents/building/${buildingId}`,
        method: 'GET'
      }),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({ type: 'Incidents', id })),
              'Incidents'
            ]
          : ['Incidents']
      // providesTags: (result) =>
      //   result
      //     ? [
      //         ...result.map(({ id }) => ({ type: 'Incidents', id })),
      //         'Incidents'
      //       ]
      //     : ['Incidents']
    }),
    getIncidentById: builder.query({
      query: (id) => ({
        url: `api/v2/incidents/${id}`,
        method: 'GET'
      }),
      invalidatesTags: ['Incidents']
    }),
    updateIncident: builder.mutation({
      query: ({ currentId, ...body }) => {
        return {
          url: `api/v2/incidents/edit/${currentId}`,
          method: 'PUT',
          body
        }
      },
      invalidatesTags: ['Incidents']
    }),
    deleteIncident: builder.mutation({
      query: (id) => ({
        url: `api/v2/incidents/delete/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Incidents']
    }),
    addNewIncident: builder.mutation({
      query: (body) => ({
        url: 'api/v2/incidents/add',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Incidents']
    }),
    getStatuses: builder.query({
      query: () => ({
        url: 'api/v2/incidents/list_statuses',
        method: 'GET',
        invalidatesTags: ['Incidents']
      })
    })
  })
})

export const {
  useGetIncidentsByBuilding,
  useGetAllIncidentsQuery,
  useAddNewIncidentMutation,
  useUpdateIncidentMutation,
  useGetIncidentByIdQuery,
  useGetStatusesQuery,
  useDeleteIncidentMutation
} = incidentsApiSlice
